export const getParamsStr = (opts = {}) => {
  const paramsStrs = [];

  if (opts.resourceId) {
    paramsStrs.push("resourceId=" + opts.resourceId);
  }
  if (opts.viewId) {
    paramsStrs.push("view=" + opts.viewId);
  }
  if (opts.query) {
    paramsStrs.push("q=" + encodeURIComponent(opts.query));
  }
  if (opts.filters && opts.filters.length > 0) {
    // filters = c1/c2,c3/c4
    paramsStrs.push("c=" + encodeURIComponent(opts.filters.map(f => encodeURIComponent(f.join("/"))).join("//")));
  }
  if (window.detailLevel !== null) {
    paramsStrs.push("t=" + encodeURIComponent(window.detailLevel));
  }
  if (window.isA11y) {
    paramsStrs.push("accessible=true");
  }

  if (paramsStrs.length > 0) {
    return "?" + paramsStrs.join("&");
  } else {
    return "";
  }
};

export const getHomeInternalUrl = () => `/${getParamsStr()}`;

export const getNodeInternalUrl = nodeCode => `/${window.language}/${(nodeCode || "").toLowerCase()}${getParamsStr()}`;

export const getNodeCategoriesInternalUrl = nodeCode =>
  `/${window.language}/${(nodeCode || "").toLowerCase()}/categories${getParamsStr()}`;

export const getPackagesInternalUrl = (nodeCode, categoryPath) =>
  `/${window.language}/${(nodeCode || "").toLowerCase()}/categories/${categoryPath.join("/")}${getParamsStr()}`;

export const getPackageInternalUrl = (nodeCode, categoryPath, packageId, resourceId, viewId) =>
  `/${window.language}/${(nodeCode || "").toLowerCase()}/${
    (categoryPath?.length || []) > 0 ? "categories/" + categoryPath.filter(el => el).join("/") + "/" : ""
  }` +
  packageId +
  getParamsStr({resourceId, viewId});

export const getPackagesSearchInternalUrl = (nodeCode, query, filters) =>
  `/${window.language}/${(nodeCode || "").toLowerCase()}/search${getParamsStr({query, filters})}`;

export const getHubDashboardsInternalUrl = () => `/${window.language}/dashboards${getParamsStr()}`;

export const getNodeDashboardsInternalUrl = nodeCode =>
  `/${window.language}/${(nodeCode || "").toLowerCase()}/dashboards${getParamsStr()}`;

export const getDashboardInternalUrl = dashboardId => `/${window.language}/dashboards/${dashboardId}${getParamsStr()}`;

export const getCustomPageInternalUrl = (customPageId, nodeCode) =>
  `/${window.language}/${nodeCode ? `${nodeCode.toLowerCase()}/` : ""}pages/${customPageId}${getParamsStr()}`;

export const getNotFoundPageInternalUrl = () => `/${window.language}/not-found/${getParamsStr()}`;
